import type { LocalRoutePoint } from "./local-api.ts";
import { emptyActivityBasis, addActivitySegment, activityFromBasis } from "../shared/activity-model.js";
export { walkingMet } from "../shared/activity-model.js";
export type ActivityEstimate = {
  distanceKm: number | null; steps: number | null; activeMinutes: number | null; averageSpeedKph: number | null; calories: number | null;
  usedSegments: number; ignoredSegments: number;
};
export function estimateWalkingActivity(points: LocalRoutePoint[], strideCm: number, weightKg: number): ActivityEstimate {
  const basis = emptyActivityBasis();
  for (let index = 1; index < points.length; index++) addActivitySegment(basis, points[index - 1], points[index]);
  return activityFromBasis(basis, { strideCm, weightKg });
}
